
import { useState, useEffect } from "react";
import { useExperience } from "@/hooks/use-experience";
import { PopupType } from "./types";

export const useAnalogHorrorProvider = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState<PopupType>("success");
  
  // Safe access to experience with error handling
  let experience = null;
  let currentLevel = 0;
  let currentRank = "";
  
  try {
    const experienceResult = useExperience();
    if (experienceResult && experienceResult.experience) {
      experience = experienceResult.experience;
      currentLevel = experience.currentLevel;
      currentRank = experience.currentRank;
    }
  } catch (error) {
    console.error("Error accessing experience data:", error);
  }
  
  const [lastLevel, setLastLevel] = useState(0);
  const [lastRank, setLastRank] = useState("");

  // Check for level/rank changes
  useEffect(() => {
    if (!experience || !lastLevel) {
      if (experience) {
        setLastLevel(currentLevel);
        setLastRank(currentRank);
      }
      return;
    }

    // Check for level up with encouraging message
    if (currentLevel > lastLevel) {
      showMessage(
        `LEVEL ACHIEVED: ${currentLevel}. Your perseverance is building a healthier body, stronger mind, and longer life. Weight loss reduces chronic disease risk and increases vitality.`,
        "level"
      );
      setLastLevel(currentLevel);
    }

    // Check for rank change with encouraging message
    if (currentRank !== lastRank && lastRank !== "") {
      showMessage(
        `NEW RANK: ${currentRank}. Your dedication is reshaping your future. Improved fitness enhances mobility, reduces pain, and extends quality of life. Continue your evolution.`,
        "level"
      );
      setLastRank(currentRank);
    }
  }, [experience, currentLevel, currentRank, lastLevel, lastRank]);

  // Show a message
  const showMessage = (newMessage: string, type: PopupType = "success") => {
    // Truncate to 240 characters as requested
    const truncatedMessage = newMessage.length > 240 
      ? newMessage.substring(0, 237) + "..." 
      : newMessage;
      
    setMessage(truncatedMessage);
    setMessageType(type);
    setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  return {
    isOpen,
    message,
    messageType,
    showMessage,
    handleClose
  };
};
